import { PreviewFrameStyled } from './PreviewFrame.styled'

export const PreviewFrame = ({ url }) => (
  <PreviewFrameStyled>
    <iframe src={url} title='Redirect' />
  </PreviewFrameStyled>
)
